import React, {useEffect} from "react";
import {createBrowserHistory} from "history";
import {useAppSettingsDataContext} from "../providers/AppSettingsProvider";
import {hasSimproSession, isInIframe} from "../utils/WindowContextUtils";

const IframeChecker: React.FC = ({children}) => {

	const {allowWithoutIframe} = useAppSettingsDataContext()

	useEffect(() => {
		if (!allowWithoutIframe && !isInIframe() && !hasSimproSession()) {
			createBrowserHistory().push('/error?direct');
			window.location.reload();
		}
	}, [allowWithoutIframe])

	return (
		<>
			{children}
		</>
	);
};

export default IframeChecker
